// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"642":"9de557f7","653":"3213bc98"}[chunkId] + ".js";
};